import { defineMessages } from 'react-intl';

const giftCardDetailsPageMessages = defineMessages({
    createYourGiftCardTitle: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.createYourGiftCardTitle',
        description: 'Create a gift card title',
        defaultMessage: 'Create your gift card'
    },
    sendByEmailDeliveryTypeText: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.sendByEmailDeliveryTypeText',
        description: 'Send by email',
        defaultMessage: 'Send by email'
    },
    headerOptionsHelperText: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.headerOptionsHelperText',
        description: 'All fields are required unless marked as optional.',
        defaultMessage: 'All fields are required unless marked as optional.'
    },
    ecoFriendlyLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.ecoFriendlyLabel',
        description: 'Eco-friendly',
        defaultMessage: 'Eco-friendly'
    },
    newFeatureHighlightText: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.newFeatureHighlightText',
        description: 'New',
        defaultMessage: 'New'
    },
    newFeatureSummaryTextDigital: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.newFeatureSummaryTextDigital',
        description: 'Send a digital card to up to 15 people!',
        defaultMessage: 'Send a digital card to up to 15 people!'
    },
    newFeatureSummaryTextPlastic: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.newFeatureSummaryTextPlastic',
        description: 'Send a digital card to up to 15 people!',
        defaultMessage: 'Send a plastic card to up to 15 people!'
    },
    newFeatureSummaryTextPrintAtHome: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.newFeatureSummaryTextPrintAtHome',
        description: 'Send a digital card to up to 15 people!',
        defaultMessage: 'Send a print at home card to up to 15 people!'
    },
    newFeaturePopUpTitlePlastic: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.newFeaturePopUpTitlePlastic',
        description: 'Send a plastic card to up to 15 people!',
        defaultMessage: 'Send a plastic card to up to 15 people!'
    },
    newFeaturePopUpTitlePrintAtHome: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.newFeaturePopUpTitlePrintAtHome',
        description: 'Send a print at home card to up to 15 people!',
        defaultMessage: 'Send a print at home card to up to 15 people!'
    },
    newFeaturePopUpTitleDigital: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.newFeaturePopUpTitleDigital',
        description: 'Send a digital card to up to 15 people!',
        defaultMessage: 'Send a digital card to up to 15 people!'
    },
    newFeaturePopUpDescriptionPlastic: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.newFeaturePopUpDescriptionPlastic',
        description: 'New offer secription for plastic',
        defaultMessage: 'When sending an eGift, you can specify up to 15 people to receive it.each recipient gets their own copy of the eGift.for instance, if you send a $10 eGift to 3 recipients, you are sending a total of eGifts, each one for $10 for a total cost of $30.'
    },
    newFeaturePopUpDescriptionPrintAtHome: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.newFeaturePopUpDescriptionPrintAtHome',
        description: 'New offer secription for print at home',
        defaultMessage: 'When sending an eGift, you can specify up to 15 people to receive it.each recipient gets their own copy of the eGift.for instance, if you send a $10 eGift to 3 recipients, you are sending a total of eGifts, each one for $10 for a total cost of $30.'
    },
    newFeaturePopUpDescriptionDigital: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.newFeaturePopUpDescriptionDigital',
        description: 'New offer secription for digital',
        defaultMessage: 'When sending an eGift, you can specify up to 15 people to receive it.\n\n'
            + '\n\n'
            + '- each recipient gets their own copy of the eGift.\n'
            + '- for instance, if you send a $10 eGift to 3 recipients, you are sending a total of '
            + '3 eGifts, each one for $10 for a total cost of $30.'
    },
    singleFaceplateActionButtonPlastic: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.singleFaceplateActionButtonPlastic',
        description: 'Buy Physical Gift Card',
        defaultMessage: 'Buy Physical Gift Card'
    },
    singleFaceplateActionButtonDigital: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.singleFaceplateActionButtonDigital',
        description: 'Buy Digital Gift Card',
        defaultMessage: 'Buy Digital Gift Card'
    },
    singleFaceplateActionButtonPrintAtHome: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.singleFaceplateActionButtonPrintAtHome',
        description: 'Buy Print At Home Gift Card',
        defaultMessage: 'Buy Print At Home Gift Card'
    },
    whyChooseDigitalLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.whyChooseDigitalLabel',
        description: 'Why choose digital?',
        defaultMessage: 'Why choose digital?'
    },
    whyChoosePlasticLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.whyChoosePlasticLabel',
        description: 'Why choose physical?',
        defaultMessage: 'Why choose physical?'
    },
    whyChoosePrintAtHomeLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.whyChoosePrintAtHomeLabel',
        description: 'Why choose print at home?',
        defaultMessage: 'Why choose print at home?'
    },
    PrintAtHomeDescriptionLabel_1: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.PrintAtHomeDescriptionLabel_1',
        description: 'A printable gift card, delivered by email.',
        defaultMessage: 'A printable gift card, delivered by email.'
    },
    PrintAtHomeDescriptionLabel_2: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.PrintAtHomeDescriptionLabel_2',
        description: 'Send it to yourself to download or print at home.',
        defaultMessage: 'Send it to yourself to download or print at home.'
    },
    deliveredInstantlyLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.deliveredInstantlyLabel',
        description: 'Send now or later',
        defaultMessage: 'Send now or later'
    },
    cardDesignLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.cardDesignLabel',
        description: 'Choose gift card design',
        defaultMessage: 'Choose gift card design'
    },
    cardNewDesignLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.cardNewDesignLabel',
        description: 'Choose a new design',
        defaultMessage: 'Choose a new design'
    },
    CurrencyPickerModalHeader: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.CurrencyPickerModalHeader',
        description: 'Choose currency',
        defaultMessage: 'Choose currency'
    },
    CategoryPickerModalHeader: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.CategoryPickerModalHeader',
        description: 'Choose category',
        defaultMessage: 'Choose category'
    },
    allDesignLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.allDesignLabel',
        description: 'All designs',
        defaultMessage: 'All designs'
    },
    quantityinputTitle: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.quantityInput',
        description: 'quantity input field',
        defaultMessage: 'Quantity'
    },
    deliveryDate: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.deliveryDate',
        description: 'Select delivery date title',
        defaultMessage: 'Delivery date'
    },
    scheduleDeliveryContainerTitle: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.scheduleDeliveryContainerTitle',
        description: 'When should it be delivered?',
        defaultMessage: 'When should it be delivered?'
    },
    deliveryDateTime: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.deliveryDateTime',
        description: 'Select delivery date & time title',
        defaultMessage: 'Delivery date & time'
    },
    deliverNow: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.deliverNow',
        description: 'Select delivery date label',
        defaultMessage: 'Deliver now'
    },
    deliveryTime: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.deliveryTime',
        description: 'Select delivery time title',
        defaultMessage: 'Delivery time'
    },
    recipientTimezone: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.recipientTimezone',
        description: 'Select delivery Timezone title',
        defaultMessage: 'Recipient\'s timezone'
    },
    recipientNameTimezone: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.recipientNameTimezone',
        description: 'Select delivery Timezone title',
        defaultMessage: '{recipientName} timezone'
    },
    chooseDeliveryTimeTitle: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.chooseDeliveryTimeTitle',
        description: 'Choose delivery time text',
        defaultMessage: 'Choose delivery time'
    },
    optionalText: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.optionalText',
        description: 'Optional text',
        defaultMessage: '(optional)'
    },
    deliveryTimeHour: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.deliveryTimeHour',
        description: 'Select delivery time hour',
        defaultMessage: 'Hour'
    },
    deliveryTimeMinute: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.deliveryTimeMinute',
        description: 'Select delivery time minute',
        defaultMessage: 'Minute'
    },
    deliveryTimeAMPM: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.deliveryTimeAMPM',
        description: 'Select delivery time AM/PM',
        defaultMessage: 'AM/PM'
    },
    deliveryTimeAM: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.deliveryTimeAM',
        description: 'AM (Ante Meridiem) for time picker',
        defaultMessage: 'AM'
    },
    deliveryTimePM: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.deliveryTimePM',
        description: 'PM (Post Meridiem) for time picker',
        defaultMessage: 'PM'
    },
    whoIsItFor: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.WhoIsItFor',
        description: 'Question asking who the gift card is for',
        defaultMessage: 'Where would you like to send it?'
    },
    shippingFormTitle: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.shippingFormTitle',
        description: 'Question asking who the gift card is for',
        defaultMessage: 'Where would you like to send it?'
    },
    editRecipientsText: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.EditRecipientsText',
        description: 'Message for edit recipients',
        defaultMessage: 'Edit'
    },
    addRecipientsMessage: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.AddRecipients',
        description: 'Message for adding recipients',
        defaultMessage: 'Add Recipients'
    },
    recipientsCountAndRemaining: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.RecipientCount',
        description: 'Message showing the number of recipients remaining',
        defaultMessage: '({remaining} of {total} remaining)'
    },
    manageRecipients: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.ManageRecipients',
        description: 'Message for managing recipients',
        defaultMessage: 'Manage recipients'
    },
    recipientSubText: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.RecipientSubText',
        description: 'Subtext for the Add recipient Modal section',
        defaultMessage: 'Each recipient will receive a {customAmount} gift card'
    },
    recipient: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.Recipient',
        description: 'Label for the recipient',
        defaultMessage: 'Recipient'
    },
    remove: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.Remove',
        description: 'Button or action label for removing recipient',
        defaultMessage: 'Remove'
    },
    confirm: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.Confirm',
        description: 'Button or action label for confirming recipient details',
        defaultMessage: 'Confirm'
    },
    maxRecipients: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.MaximumRecipients',
        description: 'Message indicating the maximum limit of recipients',
        defaultMessage: 'Maximum {max_recipients_count}'
    },
    maxRecipientAmountError: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.MaxRecipientAmountError',
        description: 'Error message when the total amount exceeds the maximum allowed for multiple recipients',
        defaultMessage: 'Maximum total order value is {maxLimit}. To add more recipients, reduce the card value.'
    },
    unsavedRecipientHeader: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.UnsavedRecipientHeader',
        description: 'Header for unsaved recipient confirmation modal',
        defaultMessage: 'You have unsaved changes'
    },
    unsavedRecipientModalContent: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.UnsavedRecipientModalContent',
        description: 'Content for unsaved recipient confirmation modal',
        defaultMessage: 'Closing this form will discard your unsaved changes. Do you want to continue?'
    },
    unsavedRecipientModalCancel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.UnsavedRecipientModalCancel',
        description: 'Cancel button text for unsaved recipient confirmation modal',
        defaultMessage: 'Cancel'
    },
    unsavedRecipientModalDiscard: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.UnsavedRecipientModalDiscard',
        description: 'Discard changes button text for unsaved recipient confirmation modal',
        defaultMessage: 'Discard changes'
    },
    multiRecipientQuantity: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.MultiRecipientQuantity',
        description: 'Label for the quantity field when multiple recipients are enabled',
        defaultMessage: ' {noOfRecipients} ({amount} for each recipient)'
    },
    CPFPopUpTitle: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.CPFPopUpTitle',
        description: 'We need your CPF number to proceed',
        defaultMessage: 'We need your CPF number to proceed'
    },
    CPFPopUpActionButton: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.CPFPopUpActionButton',
        description: 'Proceed',
        defaultMessage: 'Proceed'
    },
    buyNow: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.buyNow',
        description: 'Buy Now button text',
        defaultMessage: 'Buy Now'
    },
    charactersLeftInMessage: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.charactersLeftInMessage',
        description: 'Characters left helper text',
        defaultMessage: '{remainingNumber} / {totalNumber}'
    },
    charactersLimitReachedMessage: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.charactersLimitReachedMessage',
        description: 'Characters limit is reached',
        defaultMessage: 'You have reached your maximum character count'
    },
    charactersLimitNearingMessage: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.charactersLimitNearingMessage',
        description: 'You are near the maximum message length of 250 characters',
        defaultMessage: 'You are near the maximum message length of 250 characters'
    },
    physicalCharactersLimitNearingMessage: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.physicalCharactersLimitNearingMessage',
        description: 'You are near the maximum message length of 150 characters',
        defaultMessage: 'You are near the maximum message length of 150 characters'
    },
    deliverySelectorLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.deliverySelectorLabel',
        description: 'How would you like to send it?',
        defaultMessage: 'How would you like to send it?'
    },
    shareableLinkHelpertext: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.shareableLinkHelpertext',
        description: 'PDP Shareable link Helper Text',
        defaultMessage: '**Get a link:** The link will expire 365 days after the digital gift card is first accessed. The digital gift card does not expire. \nSee [Terms and Conditions]({termsUrl}) for more information.'
    },
    senderDetailsLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.senderDetailsLabel',
        description: 'Your details',
        defaultMessage: 'Your details'
    },
    messageDetailsLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.messageDetailsLabel',
        description: 'Your message',
        defaultMessage: 'Your message'
    },
    addAMessageOptionalLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.addAMessageOptionalLabel',
        description: 'Add a message (optional)',
        defaultMessage: '**Add a message** (optional)'
    },
    thisIsAGiftLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.thisIsAGiftLabel',
        description: 'This is a gift',
        defaultMessage: 'This is a gift'
    },
    EditCartThisIsAGiftLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.EditCartThisIsAGiftLabel',
        description: 'This is a gift',
        defaultMessage: 'This is a gift'
    },
    linkDeliveryLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.linkDeliveryLabel',
        description: 'Get a link',
        defaultMessage: 'Get a link'
    },
    linkDeliveryHelperText: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.linkDeliveryHelperText',
        description: 'Use the link yourself, or share it by text, Whatsapp, Messenger, and more.',
        defaultMessage: 'Use the link yourself, or share it by text, Whatsapp, Messenger, and more.'
    },
    invalidEmail: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.invalidEmail',
        description: 'Validation error for invalid emails',
        defaultMessage: 'Use the link yourself, or share it by text, Whatsapp, Messenger, and more.'
    },
    addToCart: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.AddToCart',
        description: 'add item to cart',
        defaultMessage: 'Add to cart'
    },
    viewCartMobile: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.viewCartMobile',
        description: 'view cart text',
        defaultMessage: 'View cart'
    },
    viewCartSummary: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.viewCartSummary',
        description: 'view cart summary',
        defaultMessage: '{count} {count, plural, one {item} other {items}}'
    },
    editCartModalHeader: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.editCartModalHeader',
        description: 'Header text for edit card modal',
        defaultMessage: 'Edit digital gift card order'
    },
    editCartPhysicalModalHeader: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.editCartPhysicalModalHeader',
        description: 'Header text for edit card physical modal',
        defaultMessage: 'Edit physical gift card order'
    },
    editCartAmount: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.editCartAmount',
        description: 'Edit cart card amount',
        defaultMessage: 'Amount: <p class="edit-cart-modal-text">{amount}</p>'
    },
    editCartDeliveryMethod: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.editCartDeliveryMethod',
        description: 'Edit cart card delivery method',
        defaultMessage: 'Send Via: <p class="edit-cart-modal-text">{deliveryMethod}</p>'
    },
    editCartDeliveryMethodEmail: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.editCartDeliveryMethodEmail',
        description: 'Edit cart delivery method value for email',
        defaultMessage: 'Email'
    },
    editCartDeliveryMethodLink: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.editCartDeliveryMethodLink',
        description: 'Edit cart delivery method value for shareable link',
        defaultMessage: 'Link'
    },
    editCartModalSaveButton: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.editCartModalSaveButton',
        description: 'Edit Cart Modal Save Button Text',
        defaultMessage: 'Save Changes'
    },
    editCartModalCancelButton: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.editCartModalCancelButton',
        description: 'Edit Cart Modal Cancel Button Text',
        defaultMessage: 'Cancel'
    },
    yourEmailLabel: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.yourEmail',
        description: 'Your Email label',
        defaultMessage: 'Your Email'
    },
    yourName: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.yourName',
        description: 'Your Name text field',
        defaultMessage: 'Your Name'
    },
    profaneMessage: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.profaneMessage',
        description: 'Profanity error message',
        defaultMessage: 'No profanity allowed'
    },
    errorMessageSummary: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.errorMessageSummary',
        description: 'Alert for summary of all alerts in the form',
        defaultMessage: 'There are {errorCount, plural, one {1 error} other {{errorCount} errors}}.Please [fix them]({firstErrorRef}) to continue.'
    },
    emailCustomPlaceholder: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.emailCustomPlaceholder',
        description: 'Custom placeholder for email fields',
        defaultMessage: 'e.g. email@abc.com'
    },
    recipientDetailsHelperText: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.recipientDetailsHelperText',
        description: 'Helper text for recipient details input',
        defaultMessage: 'Use your own email address if you don’t have recipient’s. You can share the gift with them later.'
    },
    amountCartMaxError: {
        id: 'quantity.quantityMessages.amountCartMaxError',
        description: 'Error message displayed when the provided gift card value was not allowed '
            + 'because it would exceed the maximum allowed value of a single purchase',
        defaultMessage: 'Your order total is {total}, adding {amount} '
            + 'will exceed the maximum order amount of {max}.'
    },
    amountMinError: {
        id: 'quantity.quantityMessages.amountMinError',
        description: 'Error message displayed when the provided gift card value is less than or equal to zero',
        defaultMessage: 'Please enter an amount greater than $0.00.'
    },
    invalidDenominationError: {
        id: 'quantity.quantityMessages.invalidDenominationError',
        description: 'Error message displayed when the provided gift card value is not in the list of allowed fixed denominations',
        defaultMessage: 'Please enter a valid gift card amount.'
    },
    amountCartMaxErrorEmptyCart: {
        id: 'quantity.quantityMessages.amountCartMaxErrorEmptyCart',
        description: 'Error message displayed when the provided gift card value was not allowed '
            + 'because it would exceed the maximum allowed value of a single purchase and the cart is empty',
        defaultMessage: '{amount} exceeds the maximum order amount of {max}.'
    },
    recipientGiftText: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.recipientGiftText',
        description: 'Tell the recipient to expect a gift',
        defaultMessage: 'Tell the recipient to expect a gift'
    },
    shippingOptionsText: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.shippingOptionsText',
        description: 'Delivery options',
        defaultMessage: 'Delivery options'
    },
    previousAddress: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.previousAddress',
        description: 'Use previous address',
        defaultMessage: 'Use previous address'
    },
    firstclass: {
        id: 'giftCardDetailsPage.physicalGiftCards.firstclass',
        description: 'FREE USPS First Class',
        defaultMessage: 'FREE USPS First Class'
    },
    wSignature: {
        id: 'giftCardDetailsPage.physicalGiftCards.wSignature',
        description: '$16.46 UPS 2 Day wSignature',
        defaultMessage: '$16.46 UPS 2 Day wSignature'
    },
    nextday: {
        id: 'giftCardDetailsPage.physicalGiftCards.nextday',
        description: '$22.50 UPS Next Day',
        defaultMessage: '$22.50 UPS Next Day'
    },
    holidayshipping: {
        id: 'giftCardDetailsPage.physicalGiftCards.holidayshipping',
        description: 'Holiday shipping',
        defaultMessage: 'Holiday shipping'
    },
    holidayshippingtxt: {
        id: 'giftCardDetailsPage.physicalGiftCards.holidayshippingtxt',
        description: 'Detail about holidayshippingtxt',
        defaultMessage: 'Please place your order by the following dates for an estimated delivery date prior to December 25, 2024.'
    },
    groundShipping: {
        id: 'giftCardDetailsPage.physicalGiftCards.groundShipping',
        description: 'Standard or ground shipping',
        defaultMessage: 'Standard or ground shipping'
    },
    groundShippingtxt: {
        id: 'giftCardDetailsPage.physicalGiftCards.groundShippingtxt',
        description: 'Detail about ground shipping',
        defaultMessage: 'Order by December 6.'
    },
    expeditedShipping: {
        id: 'giftCardDetailsPage.physicalGiftCards.expeditedShipping',
        description: 'Expedited shipping',
        defaultMessage: 'Expedited shipping'
    },
    expeditedShippingtxt: {
        id: 'giftCardDetailsPage.physicalGiftCards.expeditedShippingtxt',
        description: 'Detail about Expedited shipping',
        defaultMessage: 'Order by December 15.'
    },
    deliveryOptionNote: {
        id: 'giftCardDetailsPage.physicalGiftCards.deliveryOptionNote',
        description: 'Note for the delivery options',
        defaultMessage: 'This is just a guide; we cannot guarantee delivery times. Digital gift cards are an ideal way to ensure receipt in time for the holidays!'
    },
    physicalDeliveryOptionNote: {
        id: 'giftCardDetailsPage.physicalGiftCards.physicalDeliveryOptionNote',
        description: 'Note on delivery options based on address and cost',
        defaultMessage: 'Add a delivery address to see shipping options.'
    },
    cardActivationFee: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.cardActivationFee',
        description: 'activation fee  title',
        defaultMessage: 'A one time activation fee of {activationFee} per card will apply.'
    },
    cardHandlingFee: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.cardHandlingFee',
        description: 'physical card handling fee title',
        defaultMessage: 'A one time physical card handling fee of {activationFee} per card will apply.'
    },
    physicalCardMaxLimitErrorMessage: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.physicalCardMaxLimitErrorMessage',
        description: 'Alert for physicalCardMaxLimitError in the form',
        defaultMessage: 'You already have {maxCount} physical cards in your cart (limit of {maxCount} per order). To add more, choose digital cards instead.'
    },
    shippingApiFailureMessgae: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.shippingApiFailureMessgae',
        description: 'Alert for shippingApiFailureMessgae in the form',
        defaultMessage: 'Delivery options failed to load. [Try again]({tryAgain})'
    },
    fetchingNoteMessage: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.fetchingNoteMessage',
        description: 'Note for fetchingNoteMessage in the form',
        defaultMessage: ' Please wait a moment while we fetch your delivery options.'
    },
    digitalGiftCardLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.digitalGiftCardLabel',
        description: 'Digital gift card label',
        defaultMessage: 'Digital gift card'
    },
    digitalGiftCardLabelMobile: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.digitalGiftCardLabelMobile',
        description: 'Digital label',
        defaultMessage: 'Digital'
    },
    physicalGiftCardLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.physicalGiftCardLabel',
        description: 'Physical gift card label',
        defaultMessage: 'Physical gift card'
    },
    physicalGiftCardLabelMobile: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.physicalGiftCardLabelMobile',
        description: 'Physical label',
        defaultMessage: 'Physical'
    },
    printAtHomeLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.printAtHomeLabel',
        description: 'Print at home label',
        defaultMessage: 'Print at home'
    },
    cartCurrencyExists: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.cartCurrencyExists',
        description: 'Different Currency exists in Cart',
        defaultMessage: `You can use only one currency per order. {cartCurrencyCode} isn’t supported in the {cardTypeValue} Card flow — please place a separate order for other currencies.`
    },
    YesGiftCardLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.YesGiftCardLabel',
        description: 'Yes, its a gift',
        defaultMessage: 'Yes'
    },
    NoSelfBuyLabel: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.NoSelfBuyLabel',
        description: 'No, I am buying for myself',
        defaultMessage: 'No'
    },
    promoWarningPopupLabel: {
        id: 'giftCardDetailsPageV2.promoWarningPopup.label',
        description: 'Promo warning popup label',
        defaultMessage: 'Purchase options'
    },
    promoWarningPopupMessage: {
        id: 'giftCardDetailsPageV2.promoWarningPopup.message',
        description: 'Promo warning popup message',
        
        defaultMessage: 'You can continue to buy this gift card with paid shipping options, or add it to the items already in your cart for free shipping.'
    },
    calendarOkButton: {
        id: 'giftCardDetailsPageV2.giftCardDetailsPageMessages.calendarOkButton',
        description: 'Calendar popup OK button label',
        defaultMessage: 'OK'
    },
    emailDomainSpellCheckText: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.emailDomainSpellCheckText',
        description: 'Text on a clickable link for a user to change their email to the suggested value',
        defaultMessage: 'Did you mean <u>{ suggestion }</u>?'
    },
    amountTitle: {
        id: 'giftCardDetailsPage.giftCardDetailsPageMessages.amount',
        description: 'Amount title',
        defaultMessage: 'Amount'
    }
});

export default giftCardDetailsPageMessages;
